import { render, staticRenderFns } from "./05_multicover.vue?vue&type=template&id=950b0530&scoped=true&"
import script from "./05_multicover.vue?vue&type=script&lang=js&"
export * from "./05_multicover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950b0530",
  null
  
)

export default component.exports